/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbMetierDto
 */
export interface FcbMetierDto {
    /**
     * 
     * @type {number}
     * @memberof FcbMetierDto
     */
    idmetier?: number;
    /**
     * 
     * @type {number}
     * @memberof FcbMetierDto
     */
    idstade?: number;
    /**
     * 
     * @type {string}
     * @memberof FcbMetierDto
     */
    codesecteur?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FcbMetierDto
     */
    idsecteurCrea?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FcbMetierDto
     */
    code?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbMetierDto
     */
    integre?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FcbMetierDto
     */
    masculin?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbMetierDto
     */
    feminin?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbMetierDto
     */
    comissionParitaire?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbMetierDto
     */
    actif?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FcbMetierDto
     */
    remarque?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbMetierDto
     */
    pratique?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof FcbMetierDto
     */
    creationUser?: number;
    /**
     * 
     * @type {Date}
     * @memberof FcbMetierDto
     */
    creationDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof FcbMetierDto
     */
    modificationUser?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof FcbMetierDto
     */
    modificationDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof FcbMetierDto
     */
    idmetierGuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbMetierDto
     */
    degreFinal?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbMetierDto
     */
    degreFinalAdditionnel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbMetierDto
     */
    ifapmeSide?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof FcbMetierDto
     */
    commissionParitaires?: Array<number> | null;
}

/**
 * Check if a given object implements the FcbMetierDto interface.
 */
export function instanceOfFcbMetierDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbMetierDtoFromJSON(json: any): FcbMetierDto {
    return FcbMetierDtoFromJSONTyped(json, false);
}

export function FcbMetierDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbMetierDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idmetier': !exists(json, 'idmetier') ? undefined : json['idmetier'],
        'idstade': !exists(json, 'idstade') ? undefined : json['idstade'],
        'codesecteur': !exists(json, 'codesecteur') ? undefined : json['codesecteur'],
        'idsecteurCrea': !exists(json, 'idsecteurCrea') ? undefined : json['idsecteurCrea'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'integre': !exists(json, 'integre') ? undefined : json['integre'],
        'masculin': !exists(json, 'masculin') ? undefined : json['masculin'],
        'feminin': !exists(json, 'feminin') ? undefined : json['feminin'],
        'comissionParitaire': !exists(json, 'comissionParitaire') ? undefined : json['comissionParitaire'],
        'actif': !exists(json, 'actif') ? undefined : json['actif'],
        'remarque': !exists(json, 'remarque') ? undefined : json['remarque'],
        'pratique': !exists(json, 'pratique') ? undefined : json['pratique'],
        'creationUser': !exists(json, 'creationUser') ? undefined : json['creationUser'],
        'creationDate': !exists(json, 'creationDate') ? undefined : (new Date(json['creationDate'])),
        'modificationUser': !exists(json, 'modificationUser') ? undefined : json['modificationUser'],
        'modificationDate': !exists(json, 'modificationDate') ? undefined : (json['modificationDate'] === null ? null : new Date(json['modificationDate'])),
        'idmetierGuid': !exists(json, 'idmetierGuid') ? undefined : json['idmetierGuid'],
        'degreFinal': !exists(json, 'degreFinal') ? undefined : json['degreFinal'],
        'degreFinalAdditionnel': !exists(json, 'degreFinalAdditionnel') ? undefined : json['degreFinalAdditionnel'],
        'ifapmeSide': !exists(json, 'ifapmeSide') ? undefined : json['ifapmeSide'],
        'commissionParitaires': !exists(json, 'commissionParitaires') ? undefined : json['commissionParitaires'],
    };
}

export function FcbMetierDtoToJSON(value?: FcbMetierDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idmetier': value.idmetier,
        'idstade': value.idstade,
        'codesecteur': value.codesecteur,
        'idsecteurCrea': value.idsecteurCrea,
        'code': value.code,
        'integre': value.integre,
        'masculin': value.masculin,
        'feminin': value.feminin,
        'comissionParitaire': value.comissionParitaire,
        'actif': value.actif,
        'remarque': value.remarque,
        'pratique': value.pratique,
        'creationUser': value.creationUser,
        'creationDate': value.creationDate === undefined ? undefined : (value.creationDate.toISOString()),
        'modificationUser': value.modificationUser,
        'modificationDate': value.modificationDate === undefined ? undefined : (value.modificationDate === null ? null : value.modificationDate.toISOString()),
        'idmetierGuid': value.idmetierGuid,
        'degreFinal': value.degreFinal,
        'degreFinalAdditionnel': value.degreFinalAdditionnel,
        'ifapmeSide': value.ifapmeSide,
        'commissionParitaires': value.commissionParitaires,
    };
}

